<template>
  <!-- 動態表 -->
  <div id="AppMasterMaintenanceDeviceDynamics">
      <!-- 上部余白 -->
      <div style="height: 20px;" />
      <div style="margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column is-half">
            <b-field class="file">
                <b-upload v-model="uploadfile"
                  v-on:input="changeUploadfile">
                    <a class="button is-primary">
                        <b-icon icon="upload"></b-icon>
                        <span>動態表アップロード</span>
                    </a>
                </b-upload>
            </b-field>
          </div>
        </div>
      </div>
      <!-- 下部余白 -->
      <div style="height: 10px;" />
  </div>
</template>

<script>
export default {
  name: 'AppMasterMaintenanceDeviceDynamics',
  methods: {
    changeUploadfile: function () {
      var excuteApi = this.uploadInspectionFilePOST
      var successCallBack = this.uploadSuccess
      var errorCallBack = this.uploadError
      // WebAPI Call
      this.uploadApiCall(excuteApi,successCallBack,errorCallBack)
    },
    uploadInspectionFilePOST: function (client) {
      console.log('uploadfile ='+ this.uploadfile)
      return client.apis.apiMaster.uploadInspectionFilePOST({
        upfile : this.uploadfile
      })
    },
    uploadSuccess: function (result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result)
      this.uploadfile = null
    },
    uploadError: function (result) {
      this.isLoading = false
      this.showErrorMessage(result)
      this.uploadfile = null
    }
  },
  data () {
    return {
      uploadfile:null
    }
  },
  filters: {
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppMasterMaintenanceDeviceDynamics.vue